module.exports = __webpack_public_path__ + "19bff2eff0d89b5f50b713e6c6230552.png";